<template>
    <div class="tutorial-list-container">
        <div class="tutorial-list-content">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
                <el-button type="text" @click="$router.push('/user/index')">
                    <i class="el-icon-arrow-left"></i> 返回首页
                </el-button>
                <el-button type="primary" @click="$router.push('/user/tutorial_edit')">新建教程</el-button>
            </div>

            <el-card class="box-card" style="border-radius:10px;" shadow="never">
                <div slot="header" class="card-header"><span>教程列表</span></div>
                <el-table :data="recordList" stripe style="width:100%;" size="mini" v-loading="loadingRecord"
                    empty-text="暂无教程">
                    <el-table-column prop="title" label="标题" min-width="150" />
                    <el-table-column label="标签" width="160">
                        <template slot-scope="scope">
                            <el-tag
                                v-for="tag in (scope.row.tags ? (typeof scope.row.tags === 'string' ? JSON.parse(scope.row.tags) : scope.row.tags) : [])"
                                :key="tag" size="mini" style="margin:1px 2px;">{{ tag }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="80">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status == 1 ? 'success' : 'warning'" size="mini">
                                {{ scope.row.status == 1 ? '已发布' : '私密' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="time" label="上传时间" width="160" :formatter="formatDate" />
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination small layout="prev, pager, next" :page-size="10" :total="recordTotal"
                    @current-change="loadRecords" :current-page="recordPage"
                    style="margin-top:10px;text-align:right;" />
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TutorialList',
    data() {
        return {
            recordList: [],
            recordPage: 1,
            recordTotal: 0,
            loadingRecord: false
        }
    },
    methods: {
        edit(row) {
            this.$router.push('/user/tutorial_edit?id=' + row.id)
        },
        loadRecords(page) {
            this.recordPage = page || 1
            this.loadingRecord = true
            this.$ajax.get('qhy/app/tutorial_list?ismy=1&page=' + this.recordPage).then(res => {
                if (res.data.status == 200) {
                    this.recordList = res.data.data.data || []
                    this.recordTotal = res.data.data.total || 0
                }
                this.loadingRecord = false
            }).catch(() => {
                this.loadingRecord = false
            })
        },
        formatDate(row) {
            if (!row.time) return '-'
            let date = new Date(row.time * 1000)
            return date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0') + ' ' +
                String(date.getHours()).padStart(2, '0') + ':' +
                String(date.getMinutes()).padStart(2, '0') + ':' +
                String(date.getSeconds()).padStart(2, '0')
        }
    },
    created() {
        this.loadRecords(1)
    }
}
</script>

<style scoped>
.tutorial-list-container {
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 100px);
    background-color: #f6f7f8;
}

.tutorial-list-content {
    max-width: 800px;
    width: 100%;
    margin-top: 10px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/User/TutorialList.vue


// WEBPACK FOOTER //
// src/components/User/TutorialList.vue